export default function({ dispatch, commit }, params) {
    // POST /auth/change/phone
    return dispatch('post', {
        url: '/auth/change/phone',
        data: params
    }, {
        root: true
    })
    .then((response) => {
        commit('finishedAuthentication')
        return response
    })
    .catch((error) => {
        commit('finishedAuthentication')
        return error
    })
}
